import { VariantColor } from '@repo/toolkit/colors'

import { StatusOption } from '../../utils'

type MissionStatusOption = Omit<StatusOption, 'variant'> & {
  // this ensures that the variant is always defined and required since it's not optional in the StatusOption type
  variant: VariantColor
}

export enum MissionStatusEnum {
  PENDING = 'PENDING',
  PARTIALLY_AFFECTED = 'PARTIALLY_AFFECTED',
  AFFECTED = 'AFFECTED',
  OVER_AFFECTED = 'OVER_AFFECTED',
  CANCELLED = 'CANCELLED',
  PAID = 'PAID'
}

export const missionStatusEnumMapping: Record<MissionStatusEnum, MissionStatusOption> = {
  [MissionStatusEnum.PENDING]: {
    label: 'En attente',
    variant: 'warning'
  },
  [MissionStatusEnum.PARTIALLY_AFFECTED]: {
    label: 'Partiellement affecté',
    variant: 'yellow'
  },
  [MissionStatusEnum.AFFECTED]: {
    label: 'Affecté',
    variant: 'success'
  },
  [MissionStatusEnum.OVER_AFFECTED]: {
    label: 'Sur-affectée',
    variant: 'danger'
  },
  [MissionStatusEnum.CANCELLED]: {
    label: 'Annulé',
    variant: 'danger'
  },
  [MissionStatusEnum.PAID]: {
    label: 'Payée',
    variant: 'blue'
  }
}
